import { manageAddUsers, manageDelete, manageList, manageUserDelete, } from "@/api/conference";
import { Button, Collapse, Empty, Input, message, Modal, Select, Space, Table, Tag } from "antd";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import type { ColumnsType } from "antd/es/table";
import { userlists } from "@/api/users";
import { LOGININFOSTORE, METTINGPAGE_SAVED_MEETING_INFO, NORMALSETTINGKEY, } from "@/config/const";
import { conference } from "@/api";
import { notChromeMessage, storage } from "@/util";
import { checkStoredPlayTips } from "../pub";
import { ConferenceInterface, JoinMeetingInterrupt } from "@/types";
import ManageEdit from "./edit";
import { useDepts } from "@/pages/main/Users";

const { Panel } = Collapse;

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #999;
    height: 30px;
  }
  .ant-collapse {
    width: 100%;
    overflow-y: auto;
    scrollbar-gutter: stable;
  }
  .ant-btn {
    padding: 4px;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    align-items: center;
  }
`;

const userColumns: ColumnsType<any> = [
  {
    title: "登录账号",
    dataIndex: "account",
    key: "account",
  },
  {
    title: "姓名",
    dataIndex: "nickname",
    key: "nickname",
  },
  {
    title: "部门",
    dataIndex: "deptName",
    key: "deptName",
  },
  {
    title: "类型",
    dataIndex: "platformType",
    key: "platformType",
  },
];

export default function Manage() {
  const history = useHistory();

  const [allusers, setAllUsers] = useState<any[]>([]);
  const mineInfo = JSON.parse(
    window.localStorage.getItem(LOGININFOSTORE) || "{}"
  );

  const meeting = useRef<any>({});

  const getAllUsers = useCallback(async () => {
    const res = await userlists({});

    const arr = res.users.filter(
      (item: any) => item.account !== mineInfo.username
    );
    setAllUsers(arr);
  }, []);

  const [dept, setDept] = useState<number>(100);

  const { depts } = useDepts()

  const filterUser = useMemo(() => {
    const filterDept = depts.filter(item => item.ancestors.includes(dept) || item.deptId === dept);

    const deptStr = filterDept.map((item: any) => item.value).join(",")

    return allusers.filter(item =>deptStr.includes(item.deptId));
  },[dept, allusers])

  const onChange = (key: string | string[]) => {
    if (!key || (Array.isArray(key) && key.length === 0)) return;
    // rowSelection.defaultSelectedRowKeys = meeting.current.users.map((user: any) => user.account);
    // console.log("默认选中:", rowSelection.defaultSelectedRowKeys);
    // manageUser(Number(key)).then((res) => {
    //   console.log("会议成员:", res);
    //   if (res.data && res.data.length > 0) {

    //     const arr = list.map((item) => {
    //       if (item.id === Number(key)) {
    //         return {
    //           ...item,
    //           users: res.data,
    //         };
    //       }
    //       return item;
    //     });

    //     console.log("更新后的会议成员:", arr);
    //     setList(arr);
    //   }
    // })
  };

  const [list, setList] = useState([]);

  const getList = useCallback(async () => {
    const res = await manageList();

    // const arr = res.data.map((item: any) => ({
    //   ...item,
    //   users: [],
    // }));

    const arr = res.data.map((item: any) => {
      return {
        ...item,
        users: item.users.sort(
          (a: any, b: any) => Number(b.online) - Number(a.online)
        ), // 确保 users 字段存在
      };
    });

    setList(arr);
  }, []);

  useEffect(() => {
    getList();
    getAllUsers();
  }, [getList, getAllUsers]);

  const getHeader = (item: any) => {
    return (
      <>
        <div>
          <span>{item.title}</span>

          <span style={{ marginLeft: 10, color: "#999" }}>
            会议号: {item.conferenceNo}
          </span>
        </div>
        <div style={{ color: "#999" }}>创建时间: {item.createTime}</div>
      </>
    );
  };

  const deleteOne = async (id: number) => {
    await manageDelete(id);
    message.success("删除会议成功!");
    getList();
  };

  const ExtraActions = ({item}:any) => {
    const getConferenceInfo = async (cid: string, password?: string) => {
    try {
      const ret = await conference.conferenceJoin(
        {
          conferenceNo: cid,
          userName: mineInfo.username,
          password: passwordValue,
        },
        {
          "X-Conference-No": cid, //	${conferenceNo}	会议号
          "X-Device": "1", //	8
        }
      );
      const con = ret.conference as ConferenceInterface;
      con["X-Channel-Token"] = ret["X-Channel-Token"];
      con["X-Conference-Token"] = ret["X-Conference-Token"];
      con.roleCode = ret.roleCode;
      con.roomid = ret.roomid;
      con.roleName = ret.roleName;
      con.userId = ret.userid;
      con.attendList = ret.attendList;
      return con;
    } catch (e) {
      return e;
    }
  };
    const goMeeting = async (item: any) => {
      checkStoredPlayTips(item.conferenceNo);
      const browserErrMsg = notChromeMessage();
      if (browserErrMsg) {
        message.error(browserErrMsg);
        return;
      }
      const conf: any = await getConferenceInfo(item.conferenceNo);
      //异常情况处理
      if (conf.code !== undefined) {
        let code = conf.code;
        let data = conf.data;
        console.log(conf)
        if (code === JoinMeetingInterrupt.passwordNeeded) {
          console.log(`[JoinMeeting] password needed`);
          setIsPasswordDialogOpen(true)
          return
        } else if(code === JoinMeetingInterrupt.wrongPassword){
          //输入的会议密码不正确
          message.error(conf.message || "会议密码不正确，请重新输入");
        }
      } else {
        storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
        const setting = storage.get(NORMALSETTINGKEY);
        const url = `/meeting/${item.roomId}?peerId=${conf.roomid}_${conf.userId}&username=${
          mineInfo.realName
        }&audio=${!!setting.mic}&video=${!!setting.video}&speaker=${!!setting.audio}`;
        history.push(url);
      }
    };

    const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);
    const [passwordValue, setPasswordValue] = useState('');

    const handleChange = (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
    };
    const handleCancel = () => {
      setIsPasswordDialogOpen(false);
      setPasswordValue("")
    };

    const reserve = async () => {
      try {
        await conference.conferenceCreate(item);
        getList();
      } catch (error) {
        message.error("预约失败，请稍后再试");
      }
    };

    return (
      <div onClick={(e) => e.stopPropagation()}>
        {item.ownerId === mineInfo.userId ?
          <>
            {!item.resource ? <Button type="link" onClick={(event) => {
                handleChange(event)
                reserve();
              }}>
                预约会议
              </Button> :
              <Tag color="green">已预约</Tag>}
            <Button
              type="link"
              onClick={(event) => {
                handleChange(event)
                goMeeting(item);
              }}
            >
              立即入会
            </Button>
            <Button
              type="link"
              onClick={(event) => {
                handleChange(event);
                setEditConf(item)
              }}
            >
              编辑
            </Button>
            <Button
              type="link"
              danger
              onClick={(event) => {
                event.stopPropagation();
                deleteOne(item.id);
              }}
            >
              删除
            </Button>
            <Modal
              title="请输入入会密码"
              width={300}
              centered
              visible={isPasswordDialogOpen}
              onOk={(e) =>
                goMeeting(item)}
              onCancel={handleCancel}
              okText="加入"
              cancelText="取消">
              <Input value={passwordValue} onChange={(e) => (setPasswordValue(e.target.value))} placeholder="会议密码" />
            </Modal>
          </>
        : <>
            <Tag color={!item.resource ? 'processing' : 'green'}>{!item.resource ? '未' :'已'}预约</Tag>
            <Button
              type="link"
              onClick={(event) => {
                handleChange(event)
                goMeeting(item);
              }}
            >
              立即入会
            </Button>
          </>}
      </div>
    );
  };

  const Columns = (item: any): ColumnsType<any> => {
    return [
      {
        title: "Nickname",
        dataIndex: "nickname",
        key: "nickname",
      },
      {
        title: "DeptName",
        dataIndex: "deptName",
        key: "deptName",
      },
      {
        title: "platformType",
        dataIndex: "platformType",
        key: "platformType",
      },
      {
        title: "Online",
        key: "online",
        dataIndex: "online",
        width: 40,
        render: (text: any) => (
          <>
            { text ? (
              <Tag color="green">在线</Tag>
            ) : (
              <Tag color="volcano">离线</Tag>
            ) }
          </>
        ),
      },
      {
        title: "Action",
        key: "action",
        width: 40,
        render: (_: any, record: any) => (
          <Space size="middle">
            { item.ownerId === mineInfo.userId && <Button
              danger
              type="link"
              onClick={ () => {
                manageUserDelete(record.userId);
                getList();
              } }
            >
              移除
            </Button> }
          </Space>
        ),
      }
    ]
  }

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const showModal = (item: any) => {
    meeting.current = item;
    setIsModalOpen(true);
  };

  const handleOk = () => {
    if (rowSelection.selectedRowKeys.length === 0) {
      message.error("请选择要邀请的成员");
      return;
    } else {
      const users = rowSelection.selectRows.map((item: any) => {
        return {
          meetingId: meeting.current.id,
          userId: item.userId,
          roomId: meeting.current.roomId,
          conferenceNo: meeting.current.conferenceNo,
          peerId: `${meeting.current.roomId}_${item.userId}`,
        };
      });

      manageAddUsers(users)
        .then((res) => {
          getList();
          message.success("邀请成员成功");
        })
        .catch((err) => {
          console.error("邀请成员失败:", err);
          message.error("邀请成员失败，请稍后再试");
        });

      setIsModalOpen(false);
    }
  };

  const handleCancel = () => {
    rowSelection.selectedRowKeys = [];
    setIsModalOpen(false);
  };

  const rowSelection = {
    selectedRowKeys: [] as React.Key[],
    defaultSelectedRowKeys: [] as React.Key[],
    selectRows: [] as any[],
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      rowSelection.selectedRowKeys = selectedRowKeys;
      rowSelection.selectRows = selectedRows;
    },
    getCheckboxProps: (record: any) => ({
      disabled: meeting.current.users.find(
        (user: any) => user.account === record.account
      ), // Column configuration not to be checked
      name: record.name,
    }),
    selections: true,
  };

  
  const [editConf, setEditConf] = React.useState<ConferenceInterface>(null);
  const editFinish = () => {
    setEditConf(null);
    getList();
  };
  return (
    <Container>
      {!!editConf && (
        <ManageEdit
          conference={editConf}
          onClose={() => setEditConf(null)}
          editFinish={editFinish}
        ></ManageEdit>
      )}
      <div className="header">
        <span>会议管理</span>
        <Button type="link" onClick={() => history.push("/main/manage-create")}>
          新建会议
        </Button>
      </div>
      <Collapse accordion onChange={onChange} expandIconPosition="end">
        {list &&
          list.map((item) => (
            <Panel
              header={getHeader(item)}
              key={item.id}
              extra={<ExtraActions item={item}/>}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3>会议成员</h3>{" "}
                {item.ownerId === mineInfo.userId && <Button
                  style={{ display: "inline-block" }}
                  type="link"
                  onClick={() => showModal(item)}
                >
                  邀请成员
                </Button>}
              </div>
              <Table
                columns={Columns(item)}
                dataSource={item.users}
                showHeader={false}
                pagination={false}
                locale={{ emptyText: <Empty description="暂无成员"></Empty> }}
              />
            </Panel>
          ))}
      </Collapse>
      <Modal
        title="邀请成员"
        centered
        visible={isModalOpen}
        onOk={handleOk}
        width={800}
        onCancel={handleCancel}
        okText="确定"
        cancelText="取消"
      >
        <div style={{ marginBottom: 10  ,width: "100%"}}>
          <Select value={dept} onSelect={setDept} options={depts} style={{ width: "160px"}} />
        </div>
        <Table
          columns={userColumns}
          dataSource={filterUser}
          rowKey="account"
          rowSelection={rowSelection}
          pagination={false}
          scroll={{ y: 55 * 5 }}
        />
      </Modal>
    </Container>
  );
}
